import { lazy } from 'react';
import type { PageRouter } from '@tools/ui/types';

const PaymentView = lazy(
  () =>
    import(
      /* webpackChunkName: "UserViewRoutes" */ '../pages/components/main/payment/paymentView'
    )
);

const OrgPaymentsTableView = lazy(
  () =>
    import(
      /* webpackChunkName: "UserViewRoutes" */ '../pages/components/main/payments/OrgPaymentsTable'
    )
);
const SubscriptionView = lazy(
  () =>
    import(
      /* webpackChunkName: "UserViewRoutes" */ '../pages/user/subscription/SubscriptionView'
    )
);
const MainUserView = lazy(
  () =>
    import(
      /* webpackChunkName: "UserViewRoutes" */ '../pages/user/main/MainView'
    )
);

export const userViewRoutes: PageRouter[] = [
  {
    name: 'main payments table',
    path: `/main/:orgId/payments`,
    component: OrgPaymentsTableView,
    exact: true,
    tabs: []
  },
  {
    name: 'payment view',
    path: `/main/:orgId/payments/:paymentId`,
    component: PaymentView,
    exact: true,
    tabs: []
  },
  {
    name: 'main',
    path: '/main/:orgId?',
    component: MainUserView,
    exact: false,
    tabs: []
  },
  {
    name: 'subscription',
    path: '/subscription/:orgId?',
    component: SubscriptionView,
    exact: false,
    tabs: []
  }
];
